import React, { useState } from "react";
import styles from "./Wrapper.module.scss";
import { Dropdown, Empty, Menu, Spin } from "antd";

var languageFile = require("../../../public/languages/Translation");
var Spinner = require("react-spinkit");

const LPOChartWrapper = ({
	mapMobileCount,
	mapMobilePercent,
	mapDesktopCount,
	mapDesktopPercent,
	searchMobileCount,
	searchMobilePercent,
	searchDesktopCount,
	searchDesktopPercent,
	onDownloadClick,
	data,
	children,
	desc,
	label,
	loader,
	download,
	chart,
}) => {
	let params = {};
	if (chart == "customers") {
		params = {
			mapDesktopCount,
			mapDesktopPercent,
			searchMobileCount,
			searchMobilePercent,
			searchDesktopPercent,
			searchDesktopCount,
			mapMobilePercent,
			mapMobileCount,
		};
	} else if (chart == "action") {
		params = {
			mapDesktopCount,
			mapDesktopPercent,
			searchMobileCount,
			searchMobilePercent,
			mapMobilePercent,
			mapMobileCount,
		};
	} else if (chart == "conversion") {
		params = {
			mapMobileCount,
			mapDesktopCount,
			mapDesktopPercent,
		};
	}

	const menu = (
		<Menu>
			<Menu.Item
				key="1"
				onClick={onDownloadClick}>
				{languageFile[localStorage.getItem("language")]["10786"]}
			</Menu.Item>
		</Menu>
	);
	return (
		<div className={styles.card}>
			<div className={styles.headerSction}>
				<div className={styles.header}>
					<h3>{label}</h3>
					<p>{desc}</p>
				</div>
				{getChartInfo(chart, params)}
			</div>
			{loader ? (
				<div className={styles.loaderBlock}>
					<div class="graph-loader">
						<div class="loader"></div>
					</div>
				</div>
			) : (
				<div className={styles.sourceList}>
					{data && data.length > 0 ? (
						children
					) : (
						<div className={styles.noData}>
							<Empty />
						</div>
					)}
				</div>
			)}
		</div>
	);
};

export default LPOChartWrapper;

const getChartInfo = (chart, params) => {
	if (chart == "customers") {
		return (
			<div className={styles.infoWrapper}>
				<div className={styles.infoContent}>
					<span className={styles.info}>
						<span>
							{languageFile[localStorage.getItem("language")]["2073"]}
						</span>
						<span className={styles.infoCount}>{params.mapMobileCount}</span>
						<span className={styles.infoPercent}>
							{params.mapMobilePercent}
						</span>
					</span>
				</div>
				<div className={styles.infoContent}>
					<span className={styles.info}>
						<span>
							{languageFile[localStorage.getItem("language")]["2074"]}
						</span>
						<span className={styles.infoCount}>{params.mapDesktopCount}</span>
						<span className={styles.infoPercent}>
							{params.mapDesktopPercent}
						</span>
					</span>
				</div>
				<div className={styles.infoContent}>
					<span className={styles.info}>
						<span>
							{languageFile[localStorage.getItem("language")]["2075"]}
						</span>
						<span className={styles.infoCount}>{params.searchMobileCount}</span>
						<span className={styles.infoPercent}>
							{params.searchMobilePercent}
						</span>
					</span>
				</div>
				<div className={styles.infoContent}>
					<span className={styles.info}>
						<span>
							{languageFile[localStorage.getItem("language")]["2076"]}
						</span>
						<span className={styles.infoCount}>
							{params.searchDesktopCount}
						</span>
						<span className={styles.infoPercent}>
							{params.searchDesktopPercent}
						</span>
					</span>
				</div>
			</div>
		);
	}
	if (chart == "action") {
		return (
			<div className={styles.infoWrapper}>
				<div className={styles.infoContent}>
					<span className={styles.info}>
						<span>
							{languageFile[localStorage.getItem("language")]["10792"]}
						</span>
						<span className={styles.infoCount}>{params.mapMobileCount}</span>
						<span className={styles.infoPercent}>
							{params.mapMobilePercent}
						</span>
					</span>
				</div>
				<div className={styles.infoContent}>
					<span className={styles.info}>
						<span>
							{languageFile[localStorage.getItem("language")]["13132"]}
						</span>
						<span className={styles.infoCount}>{params.mapDesktopCount}</span>
						<span className={styles.infoPercent}>
							{params.mapDesktopPercent}
						</span>
					</span>
				</div>
				<div className={styles.infoContent}>
					<span className={styles.info}>
						<span>
							{languageFile[localStorage.getItem("language")]["14523"]}
						</span>
						<span className={styles.infoCount}>{params.searchMobileCount}</span>
						<span className={styles.infoPercent}>
							{params.searchMobilePercent}
						</span>
					</span>
				</div>
			</div>
		);
	} else {
		return (
			<div className={styles.infoWrapper}>
				<div className={styles.infoContent}>
					<span className={styles.info}>
						<span>
							{languageFile[localStorage.getItem("language")]["10792"]}
						</span>
						<span className={styles.infoCount}>
							{params.mapMobileCount == "NaN%" ? "-" : params.mapMobileCount}
						</span>
					</span>
				</div>
				<div className={styles.infoContent}>
					<span className={styles.info}>
						<span>
							{languageFile[localStorage.getItem("language")]["13132"]}
						</span>
						<span className={styles.infoCount}>
							{params.mapDesktopCount == "NaN%" ? "-" : params.mapDesktopCount}
						</span>
					</span>
				</div>
				<div className={styles.infoContent}>
					<span className={styles.info}>
						<span>
							{languageFile[localStorage.getItem("language")]["14523"]}
						</span>
						<span className={styles.infoCount}>
							{params.mapDesktopPercent == "NaN%"
								? "-"
								: params.mapDesktopPercent}
						</span>
					</span>
				</div>
			</div>
		);
	}
};
